import { useState } from 'react';
import { __ } from '@wordpress/i18n';
import { RangeControl } from '@wordpress/components';
import { BDevice, BorderControl, ColorControl, Label } from '../../../../Components';
import Column from '../../settings/Components/Column/Column';
import Row from '../../settings/Components/Row/Row';
import { PanelRow } from '@wordpress/components';


const StyleField = ({ data, setData }) => {
    const { btnBorder, btnSize = { desktop: 60, tablet: 50, mobile: 40 }, btnColor, btnActiveColor, btnBgColor } = data;
    const [device, setDevice] = useState('desktop');

    return <>
        <Row gap={10}>
            <Column span={6}>
                <BorderControl className='' label={__('Border', 'bpwsnb')} value={btnBorder}
                    onChange={(val) => { setData({ ...data, btnBorder: val }) }} />
            </Column>
            <Column span={6}>

                <PanelRow>
                    <Label mt='0'>{__('Size', 'swipe-n-buy')}</Label>
                    <BDevice device={device} onChange={val => setDevice(val)} />
                </PanelRow>

                <RangeControl
                    value={btnSize[device]}
                    onChange={(val) => { setData({ ...data, btnSize: { ...btnSize, [device]: val, }, }); }}
                    step={1}
                    beforeIcon='grid-view'
                />

            </Column>
        </Row>

        <Row gap={10}>
            <Column span={6}>
                <ColorControl className='mb15' label={__('Color', 'bpwsnb')} value={btnColor} onChange={(val) => setData({ ...data, btnColor: val })} />
            </Column>

            <Column span={6}>
                <ColorControl className='mb15' label={__('Active Color', 'bpwsnb')} value={btnActiveColor} onChange={(val) => setData({ ...data, btnActiveColor: val })} />
            </Column>
        </Row>

        <Row>
            <Column span={6}>
                <ColorControl className='mb15' label={__('Background Color', 'bpwsnb')} value={btnBgColor} onChange={(val) => setData({ ...data, btnBgColor: val })} />
            </Column>
        </Row>
    </>
}
export default StyleField;